<script setup lang="ts">
// interface Props {
//   // modelValue: string
// }

// defineProps<Props>()

// defineEmits<{
//   // (event: 'update:modelValue', payload: string): void
// }>()
</script>

<template>
  <div>
    <q-img
      src="/img/register-purple-desktop.webp"
      spinner-color="white"
      class="absolute desktop-only"
      style="width: 10vw; bottom: 22dvh; right: 0"
    />
    <q-img
      src="/img/register-star-desktop.webp"
      spinner-color="white"
      class="absolute desktop-only"
      style="width: 16vw; bottom: 0; right: 10vw"
    />
    <q-img
      src="/img/register-yellow-desktop.webp"
      spinner-color="white"
      class="absolute desktop-only"
      style="width: 14vw; top: 20dvh; right: 8vw"
    />
  </div>
</template>
